/**
 * Đọc đăng ký thông báo đẩy HIỆN TẠI của trình duyệt — không phụ thuộc React.
 *
 * ⚠️ VÌ SAO CẦN FILE NÀY: Provider.registerEndpoint chỉ đọc biến toàn cục `endpoint`
 * (khai `var endpoint` trong public/<brand>/configs.js), mà biến đó lại do hook
 * usePushNotifications đặt — tức là CHỈ khi màn hình Thông báo được mở. Đổi công ty
 * (setApp/changeApp) mà không mở màn hình đó thì `endpoint` rỗng, registerEndpoint lặng lẽ
 * thoát ở `if(!endpointStr) return`, và vì mỗi bản ghi endpoint nay gắn với một công ty
 * (khoá ep_id + id_app) nên công ty vừa chuyển sang KHÔNG có đăng ký nào -> không nhận được
 * thông báo cho tới khi người dùng tự tay đăng ký lại.
 *
 * Hàm dưới đây hỏi thẳng service worker nên luôn có câu trả lời đúng, ở bất kỳ màn hình nào.
 */

/** Chờ có giới hạn — không để luồng đăng nhập/đổi công ty treo vì service worker chưa sẵn sàng. */
const withTimeout = (promise, ms) => Promise.race([
  promise,
  new Promise((resolve) => setTimeout(() => resolve(null), ms))
]);

/**
 * @returns {Promise<string|null>} chuỗi JSON của PushSubscription, hoặc null nếu máy này chưa bật.
 * Đồng thời cập nhật biến toàn cục `window.endpoint` để mã cũ (ứng dụng di động, logoutAPI) vẫn chạy.
 */
export async function getCurrentPushEndpoint() {
  try {
    if (typeof window === 'undefined') return null;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
    // KHÔNG dùng navigator.serviceWorker.ready: nó không bao giờ resolve khi trang chưa bị
    // service worker điều khiển (lần tải đầu, hoặc SW mới cài chưa claim).
    const reg = await withTimeout(navigator.serviceWorker.getRegistration(), 5000);
    if (!reg) return null;
    const sub = await withTimeout(reg.pushManager.getSubscription(), 5000);
    const str = sub ? JSON.stringify(sub) : null;
    window.endpoint = str || undefined;    // không bao giờ để lọt chuỗi "null"
    return str;
  } catch (e) {
    console.warn("[push] không đọc được đăng ký hiện tại:", e && e.message);
    return null;
  }
}

export default getCurrentPushEndpoint;
